<template>
  <div>
    <div class="NativePage">
      <van-swipe ref="TopSwipe" :autoplay="6000" @change="onTopSwipe">

        <van-swipe-item v-for="(image, index) in images" :key="index">
          <img :src="image.img" style="width:100%" @click="topAdClick(image.url)">
        </van-swipe-item>
        <div slot="indicator" class="custom-indicator swipeTop">
          <span v-for="(image, index) in images" :key="index" @click="gotoTopSwipe(index)">
            <a v-if="NowTopSwipe == index" class="mainColor"><i class="iconfont iconline" /></a>
            <a v-if="NowTopSwipe != index"><i class="iconfont iconline" /></a>
          </span>
        </div>
      </van-swipe>

      <div class="userInfo">
        <van-skeleton title avatar :row="7" :loading="loadingUserInfo">
          <div v-if="userinfo &&userinfo.SSIMemberId!=null">
            <van-row>
              <van-col span="12" style="font-weight: 900">个人信息</van-col>
              <van-col span="12" style="text-align:right"><i class="iconfont iconshezhi" @click="nativeUrl('/users/updateinfo')" /></van-col>
            </van-row>
            <van-row style="margin-top:1em;">
              <van-col span="8">
                <van-image
                  class="userIcon"
                  width="5em"
                  height="5em"
                  fit="cover"
                  :src="userinfo.iconImage?userinfo.iconImage:'aaaaaaaaaaaaaaa'"
                  @click="nativeUrl('/users/changeIcon')"
                >
                  <template v-slot:error>上传头像</template>
                </van-image>

              </van-col>
              <van-col span="16" style="position: relative;">
                <div class="pageTitle1">{{ userinfo.firstName.toUpperCase()+" "+userinfo.lastName.toUpperCase() }}</div>
                <div class="pagebody2 t1">我是SSI潜水员！{{ since }}<br>我已考取{{ certificationNum }}张潜水证书!</div>
              </van-col>
            </van-row>
            <van-row style="margin-top:1em;" class="pagebody2 infoLine">
              <van-col span="12">
                姓名: {{ userinfo.firstName+" "+userinfo.lastName }}<br>
                生日: {{ formatDate(userinfo.birthday, 'yyyy-MM-dd') }}<br>
                性别: {{ GetEnumText("Em_Sex",userinfo.sex) }}<br>
                语言: {{ getLanguageText(userinfo.language) }}<br>
                昵称: {{ userinfo.nickName }}<br>
              </van-col>
              <van-col span="12">
                国家: {{ getCountryText(userinfo.country) }}<br>
                城市: {{ userinfo.city }}<br>
                单位: {{ GetEnumText("Em_units",userinfo.units) }}<br>
                邮编: {{ userinfo.zip }}<br>
                MID : {{ userinfo.SSIMemberId }}<br>
              </van-col>
              <van-col span="24">
                地址: {{ userinfo.street }} {{ userinfo.street2 }}
              </van-col>
            </van-row>
          </div>
          <div v-else>
            <van-row>
              <van-col span="12" style="font-weight: 900">个人信息</van-col>
            </van-row>
            <van-row style="margin-top:1em;">
              <van-col span="8">
                <div class="userIcon">
                  <i class="iconfont iconwode" />
                </div>
              </van-col>
              <van-col span="16" class="needBind">
                <span @click="bingAccount"> 点击登录绑定My SSI账号</span>
              </van-col>
            </van-row>
          </div>
        </van-skeleton>
      </div>

      <div v-if="userinfo && userinfo.isManageUser" class="menuList">
        <div @click="nativeUrl('/activity/cardApprove')"><i class="iconfont iconssijob" /> <span>用户潜水员身份审核</span><i class="iconfont iconright rightGoto" /></div>
      </div>

      <div v-if="userinfo && userinfo.isProUser" class="menuList">
        <div @click="nativeUrl('/textbook/applicationTextbookList')"><i class="iconfont iconssijob" /> <span>教学教材申请</span><i class="iconfont iconright rightGoto" /></div>
        <div @click="nativeUrl('/textbook/teachingProgressList')"><i class="iconfont iconssijob" /> <span>教学进度跟踪</span><i class="iconfont iconright rightGoto" /></div>
      </div>

      <div class="menuList">
        <div @click="nativeUrl('/textbook/license')"><i class="iconfont iconusercard" /> <span>{{ $t('myself.ecard') }}</span><i class="iconfont iconright rightGoto" /></div>
        <div @click="nativeUrl('/store/orderList')"><i class="iconfont icondingdan" /> <span>{{ $t('myself.order') }}</span><i class="iconfont iconright rightGoto" /></div>
        <div @click="nativeUrl('/store/globalMydivecenterList?backurl=/users/index')"><i class="iconfont icontechdive" /> <span>{{ $t('myself.mydivecenter') }}</span><i class="iconfont iconright rightGoto" /></div>
        <div @click="nativeUrl('/store/addressList?type=null')"><i class="iconfont iconaddress" /> <span>{{ $t('myself.address') }}</span><i class="iconfont iconright rightGoto" /></div>
        <div @click="nativeUrl('/store/studentList?backurl=/users/index')"><i class="iconfont iconperson" /> <span>{{ $t('myself.student') }}</span><i class="iconfont iconright rightGoto" /></div>
        <div @click="nativeUrl('/users/job')"><i class="iconfont iconssijob" /> <span>{{ $t('myself.jobs') }}</span><i class="iconfont iconright rightGoto" /></div>
        <div @click="nativeUrl('/users/help')"><i class="iconfont iconhelp" /> <span>{{ $t('myself.helper') }}</span><i class="iconfont iconright rightGoto" /></div>
        <div @click="nativeUrl('/home/staticPage/about?backurl=/users/index')"><i class="iconfont iconabout" /> <span>{{ $t('myself.about') }}</span><i class="iconfont iconright rightGoto" /></div>
        <div @click="onSwitchingLanguage"><i class="iconfont iconcountry" /> <span>{{ $t('base.nextLanguage') }}</span><i class="iconfont iconright rightGoto" /></div>
        <div v-if="getIsLogin()" @click="unBind"><i class="iconfont iconquit" /> <span style="color:#E32119">{{ $t('myself.loginout') }}</span><i class="iconfont iconright rightGoto" /></div>
      </div>
    </div>

    <NativeBar select="users" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Notify, Swipe, SwipeItem, Lazyload, Dialog, Image, Skeleton } from 'vant'
import NativeBar from '@/components/NativeBar'
import { initPage, formatDate, getLanguageText, getCountryText, GetEnumText } from '@/utils/base'
import Cookies from 'js-cookie'
export default {
  components: {
    [Button.name]: Button,
    [Notify.name]: Notify,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Lazyload.name]: Lazyload,
    [Dialog.name]: Dialog,
    [Image.name]: Image,
    [Skeleton.name]: Skeleton,
    NativeBar
  },
  data() {
    return {
      loadingUserInfo: true,
      test: undefined,
      NowTopSwipe: 0,
      images: [
        {
          img: '/img/user/2.jpg',
          url: undefined
        },
        {
          img: '/img/user/3.jpg',
          url: undefined
        },
        {
          img: '/img/user/4.jpg',
          url: undefined
        },
        {
          img: '/img/user/5.jpg',
          url: undefined
        }
      ],
      userinfo: {
        SSIMemberId: undefined,
        bindSSITime: undefined,
        birthday: '-',
        city: '-',
        country: '-',
        createTime: undefined,
        email: undefined,
        firstName: '-',
        iconImage: undefined,
        language: '-',
        lastName: '-',
        phone: undefined,
        phoneArea: undefined,
        sex: '-',
        street: '-',
        street2: '-',
        units: undefined,
        userId: undefined,
        zip: '-'
      },
      since: '',
      certificationNum: 0
    }
  },
  created() {
    initPage()
    this.init()
  },
  methods: {
    getLanguageText,
    getCountryText,
    GetEnumText,
    formatDate,
    init() {
      request({
        url: '/user/getUserPageInfo',
        method: 'post'
      }).then(response => {
        console.log(response)
        this.userinfo = response.data.user
        this.certificationNum = response.data.certificationNum
        if (response.data.certificationBeginDate) {
          this.since = '自' + formatDate(response.data.certificationBeginDate, 'yyyy') + '年' + formatDate(response.data.certificationBeginDate, 'MM') + '月起，'
        } else {
          this.since = '自开始潜水以来，'
        }
        this.loadingUserInfo = false
      })
    },
    onSwitchingLanguage() {
      var lang = Cookies.get('language_system')
      if (!lang) {
        lang = 'zh'
      }
      // 交换
      if (lang === 'zh') {
        lang = 'en'
      } else {
        lang = 'zh'
      }
      this.$i18n.locale = lang
      Cookies.set('language_system', lang)
    },
    onTopSwipe(index) {
      this.NowTopSwipe = index
    },
    gotoTopSwipe(index) {
      this.NowTopSwipe = index
      this.$refs.TopSwipe.swipeTo(index)
    },
    nativeUrl(url) {
      this.$router.replace(url)
    },
    getIsLogin() {
      return this.$store.getters.bindPhone === true
    },
    unBind() {
      Dialog.confirm({
        title: '退出登录',
        message: '是否要退出登录，退出后需要重新验证手机!',
        cancelButtonText: '取消',
        confirmButtonText: '退出'
      }).then(() => {
        request({
          url: '/user/UnBindPhone',
          method: 'post'
        }).then(response => {
          if (response.success) {
            this.$store.dispatch('user/resetToken', response.data)
            this.userinfo = undefined
            this.init()
          }
        })
      })
    },
    bingAccount() {
      if (this.$store.getters.bindPhone === true) {
        this.$router.replace('/users/bindSSI?url=/users/index')
      } else {
        this.$router.replace('/users/regPhone?url=/users/index')
      }
    },
    topAdClick(url) {
      if (url !== undefined) {
        if (url.indexOf('/') === 0) {
          this.$router.replace(url)
        } else {
          this.$router.replace('/home/staticPage/' + url + '?backurl=/users/index')
        }
      }
    }
  }
}
</script>

<style scoped>

.userInfo{
    margin: 1em 1em;
    background-color: #fff;
    border-top: 0.2em solid #000;
    padding: 1em;
}
.userIcon{
    width: 5em;
    height: 5em;
    object-fit:cover;
    background-color: #f8f8f8;
    text-align: center;
    line-height: 5em;
    color: #969799;
}

.t1{
    height: 1.2em;
    position:absolute;
    top: 3em;
}

.menuList{
    margin: 1em 1em;
    background-color: #fff;
    padding: 0.5em 1em;
}
.menuList .rightGoto{
    float:right;
    /* margin-top: 0.1em; */
    color: #a0a0a0;
}
.menuList div{
  line-height: 1em;
  font-size: 1em;
    border-bottom: #e0e0e0 solid 1px;
    padding: 0.9em 0;
}
.menuList div:last-child{
  border-bottom:none;
}
.menuList div span{
    margin-left: 0.9em;
}
.infoLine{
   line-height: 1.6em;
}
.needBind{
  margin-top: 2em;
  line-height: 1em;
  color: #AAAAAA;
}
.needBind span{
padding-bottom: 0.2em;
border-bottom: 1px solid;
}
</style>
